import { z } from "zod"

// One http(s) URL check for the whole app — used for image URLs (writer
// image-pick candidates, Octopia product pictures) instead of hand-rolled
// `^https?://` regexes scattered per call site. Backed by Zod's url validator,
// constrained to the http(s) scheme.
const httpUrlSchema = z
  .string()
  .url()
  .refine((value) => /^https?:\/\//i.test(value), { message: "must be an http(s) URL" })

export function isHttpUrl(value: string): boolean {
  return httpUrlSchema.safeParse(value).success
}

export function normalizeLocalReturnTo(value: string | undefined, fallback = "/"): string {
  if (!value?.startsWith("/") || value.startsWith("//")) {
    return fallback
  }

  const localOrigin = "https://nova.invalid"
  const parsed = new URL(value, localOrigin)
  if (parsed.origin !== localOrigin || parsed.pathname === "/login") {
    return fallback
  }
  return `${parsed.pathname}${parsed.search}`
}
